import { http } from '@/core/helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { Appointment } from './appointment.interface';
export class AppointmentService {
   async getAppointments() {
      throw Error('Method not implemented');
   }

   async getAppointment() {
      throw Error('Method not implemented');
   }

   async postAppointment(appointment: Appointment) {
      const response = await http.post<ApiResource<Appointment>>(`/appointments`, appointment);
      return response.data;
   }

   async putAppointment() {
      throw Error('Method not implemented');
   }

   async deleteAppointment() {
      throw Error('Method not implemented');
   }
}
